import React from 'react';
import * as msgpub from "msgpub";
import {TextArea, ButtonG, QoS} from '../Common';
import { DisablesContext } from '../../constant/UserMqtt';
import { Grid, Box, TextInput, ResponsiveContext, CheckBox } from 'grommet';
import { MainStyleForGrommet } from '../../constant/Styles';
import { status_mapper, apptopicstatus_mapper } from '../../common/common';

const AREAS: {[key: string]: any[]} = {
    small: [
        { name: 'col1', start: [0, 0], end: [1, 0] },
        { name: 'col2', start: [0, 1], end: [1, 1] },
        { name: 'col3', start: [0, 2], end: [1, 2] },
        { name: 'col4', start: [0, 3], end: [1, 3] },
        { name: 'col5', start: [0, 4], end: [1, 4] },
        { name: 'col6', start: [0, 5], end: [1, 5] }
    ],
    medium: [
        { name: 'col1', start: [0, 0], end: [1, 0] },
        { name: 'col2', start: [1, 0], end: [2, 0] },
        { name: 'col3', start: [2, 0], end: [3, 0] },
        { name: 'col4', start: [3, 0], end: [4, 0] },
        { name: 'col5', start: [4, 0], end: [5, 0] },
        { name: 'col6', start: [5, 0], end: [6, 0] }
    ],
    large: [
        { name: 'col1', start: [0, 0], end: [1, 0] },
        { name: 'col2', start: [1, 0], end: [2, 0] },
        { name: 'col3', start: [2, 0], end: [3, 0] },
        { name: 'col4', start: [3, 0], end: [4, 0] },
        { name: 'col5', start: [4, 0], end: [5, 0] },
        { name: 'col6', start: [5, 0], end: [6, 0] }
    ]
};

// サイズ
const TOPIC_LABEL_WIDTH = "200px";
const QoS_WIDTH = "220px";
const PUB_BUTTON_WIDTH = "150px";
const PUB_RAW_BUTTON_WIDTH = "180px";
const RETAIN_WIDTH = "100px";

const ROWS: {[key: string]: any[]} = {
    small: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
    medium: ['auto'],
    large: ['auto']
};

const COLUMNS: {[key: string]: any[]} = {
    small: ['auto'],
    medium: [TOPIC_LABEL_WIDTH, 'flex', QoS_WIDTH, RETAIN_WIDTH, PUB_BUTTON_WIDTH, PUB_RAW_BUTTON_WIDTH],
    large: [TOPIC_LABEL_WIDTH, 'flex', QoS_WIDTH, RETAIN_WIDTH, PUB_BUTTON_WIDTH, PUB_RAW_BUTTON_WIDTH]
}

export default function PublishComponent(props: {user?: msgpub.User, setRecv: any, log: string, setLog: any}) {
    const {user, log, setLog} = props;
    const [topic, setTopic] = React.useState("");
    const [label, setLabel] = React.useState("");
    const [payloadForTopic, setPayloadForTopic] = React.useState("");
    const [payloadForLabel, setPayloadForLabel] = React.useState("");
    const [qosForTopic, setQosForTopic] = React.useState(msgpub.QoS.AT_MOST_ONCE);
    const [qosForLabel, setQosForLabel] = React.useState(msgpub.QoS.AT_MOST_ONCE);
    const [retain, setRetain] = React.useState(false);
    const [retainForLabel, setRetainForLabel] = React.useState(false);
    const disables = React.useContext(DisablesContext);
    const size = React.useContext(ResponsiveContext);
    const rows = ROWS[size];
    const columns = COLUMNS[size];
    const areas = AREAS[size];

    const publishForTopic = () => {
        const appTopic = topic.split(":");
        user?.publish({
            at: appTopic.length === 1 ? { topic: topic } : {topic: appTopic[1], app: appTopic[0] },
            callback: (status) => {
                setLog((prevLog: string) => (prevLog + "publish status = " + status_mapper(status) + "\n"));
            },
            message: payloadForTopic,
            qos: qosForTopic,
            retain: retain
        });
    };

    const publishRawForTopic = () => {
        const appTopic = topic.split(":");
        user?.publishRaw({
            at: appTopic.length === 1 ? { topic: topic } : {topic: appTopic[1], app: appTopic[0] },
            callback: (status) => {
                setLog((prevLog: string) => (prevLog + "publish status = " + status_mapper(status) + "\n"));
            },
            message: Buffer.from(payloadForTopic, 'utf-8'),
            qos: qosForTopic,
            retain: retain
        });
    };

    const publishForLabel = () => {
        const appLabel = label.split(":");
        user?.publishLabel({
            al: appLabel.length === 1 ? { label: label } : { label: appLabel[1], app: appLabel[0] },
            callback: (labelResult: msgpub.LabelResult) => {
                // @ts-ignore
                labelResult["status"] = status_mapper(labelResult["status"]);
                labelResult["appTopicStatusList"] = apptopicstatus_mapper(labelResult["appTopicStatusList"]);
                setLog((prevLog: string) => (prevLog + "LabelResult = " + JSON.stringify(labelResult) + "\n"));
            },
            message: payloadForLabel,
            qos: qosForLabel,
            retain: retainForLabel
        });
    };

    const publishRawForLabel = () => {
        const appLabel = label.split(":");
        user?.publishRawLabel({
            al: appLabel.length === 1 ? { label: label } : { label: appLabel[1], app: appLabel[0] },
            callback: (labelResult: msgpub.LabelResult) => {
                // @ts-ignore
                labelResult["status"] = status_mapper(labelResult["status"]);
                labelResult["appTopicStatusList"] = apptopicstatus_mapper(labelResult["appTopicStatusList"]);
                setLog((prevLog: string) => (prevLog + "LabelResult = " + JSON.stringify(labelResult) + "\n"));
            },
            message: Buffer.from(payloadForLabel, 'utf-8'),
            qos: qosForLabel,
            retain: retainForLabel
        });
    };

    const onChangeForTopic = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTopic(event.target.value);
    }

    const onChangeForPayloadTopic = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPayloadForTopic(event.target.value);
    }

    const onChangeForLabel = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLabel(event.target.value);
    }

    const onChangeForPayloadLabel = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPayloadForLabel(event.target.value);
    }

    const onChangeForRetain = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRetain((prev: boolean) => {return !prev});
    }

    const onChangeForRetainForLabel = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRetainForLabel((prev: boolean) => {return !prev});
    }

    return (
        <div>
            <Box {...MainStyleForGrommet}>
                <Grid
                    rows={rows}
                    columns={columns}
                    gap="xsmall"
                    areas={areas}
                >
                    <Box gridArea="col1" width={TOPIC_LABEL_WIDTH}>
                        <TextInput placeholder="topic" value={topic} onChange={onChangeForTopic} disabled={disables.pub}/>
                    </Box>
                    <Box gridArea="col2">
                        <TextInput placeholder="payload" value={payloadForTopic} onChange={onChangeForPayloadTopic} disabled={disables.pub}/>
                    </Box>
                    <Box gridArea="col3">
                        <QoS setQos={setQosForTopic} disabled={disables.pub} />
                    </Box>
                    <Box gridArea="col4" width={RETAIN_WIDTH}>
                        <CheckBox label={"retain"} checked={retain} onChange={onChangeForRetain} disabled={disables.pub} />
                    </Box>
                    <Box gridArea="col5" width={PUB_BUTTON_WIDTH}>
                        <ButtonG name="pub" callback={publishForTopic} disabled={disables.pub}/>
                    </Box>
                    <Box gridArea="col6" width={PUB_RAW_BUTTON_WIDTH} >
                        <ButtonG name="pub raw" callback={publishRawForTopic} disabled={disables.pub} />
                    </Box>
                </Grid>
            </Box>
            <Box {...MainStyleForGrommet}>
                <Grid
                    rows={rows}
                    columns={columns}
                    gap="xsmall"
                    areas={areas}
                >
                    <Box gridArea="col1" width={TOPIC_LABEL_WIDTH}>
                        <TextInput placeholder="label" value={label} onChange={onChangeForLabel} disabled={disables.pub}/>
                    </Box>
                    <Box gridArea="col2" width={'flex'}>
                        <TextInput placeholder="payload" value={payloadForLabel} onChange={onChangeForPayloadLabel} disabled={disables.pub}/>
                    </Box>
                    <Box gridArea="col3" width={QoS_WIDTH}>
                        <QoS setQos={setQosForLabel} disabled={disables.pub} />
                    </Box>
                    <Box gridArea="col4" width={RETAIN_WIDTH}>
                        <CheckBox label={"retain"} checked={retainForLabel} onChange={onChangeForRetainForLabel} disabled={disables.pub} />
                    </Box>
                    <Box gridArea="col5" width={PUB_BUTTON_WIDTH}>
                        <ButtonG name="pub label" callback={publishForLabel} disabled={disables.pub} />
                    </Box>
                    <Box gridArea="col6" width={PUB_RAW_BUTTON_WIDTH} >
                        <ButtonG name="pub raw label" callback={publishRawForLabel} disabled={disables.pub} />
                    </Box>
                </Grid>
            </Box>
            <TextArea texts={log} name={"Publish log"} disabled={disables.pub} id={"publishLog"} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setLog(e.target.value)}}/>
        </div>
    );
}
